import React from 'react'
import PropTypes from 'prop-types'

// mui core
import GridContainer from '../../components/Grid/GridContainer.js'
import GridItem from '../../components/Grid/GridItem.js'
import Card from '../../components/Card/Card.js'
import CardBody from '../../components/Card/CardBody.js'

export default function SummaryFigures ({ noSales, cancelled, voids, discounts }) {
  React.useEffect(() => {
  }, [])

  const rowHeight = '90px'

  return <GridContainer alignItems="stretch">
    <GridItem xs={12} sm={12} md={6} lg={3} xl={3} style={{ height: rowHeight, marginBottom: '5px' }}>
      <Card style={{ marginTop: 0, height: '100%' }}>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <div style={{ height: '100%' }}>No Sales</div>
            </GridItem>
            <GridItem xs={12}>
              <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{noSales}</h3></div>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
    <GridItem xs={12} sm={12} md={6} lg={3} xl={3} style={{ height: rowHeight, marginBottom: '5px' }}>
      <Card style={{ marginTop: 0, height: '100%' }}>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <div style={{ height: '100%' }}>Cancelled</div>
            </GridItem>
            <GridItem xs={12}>
              <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{cancelled}</h3></div>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
    <GridItem xs={12} sm={12} md={6} lg={3} xl={3} style={{ height: rowHeight, marginBottom: '5px' }}>
      <Card style={{ marginTop: 0, height: '100%' }}>
        <CardBody>
          <GridContainer>
            <GridItem xs={12}>
              <div style={{ height: '100%' }}>Voids</div>
            </GridItem>
            <GridItem xs={12}>
              <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{voids}</h3></div>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
    <GridItem xs={12} sm={12} md={6} lg={3} xl={3} style={{ height: rowHeight, marginBottom: '5px' }}>
      <Card style={{ marginTop: 0, height: '100%' }}>
        <CardBody>
          <GridContainer>
            <GridItem xs={6}>
              <div style={{ height: '100%' }}>Discounts</div>
            </GridItem>
            <GridItem xs={6}>
              <div style={{ height: '100%', textAlign: 'right' }}></div>
            </GridItem>
            <GridItem xs={12}>
              <div style={{ textAlign: 'right' }}><h3 style={{ margin: '0', lineHeight: '1.8em' }}>{discounts}</h3></div>
            </GridItem>
          </GridContainer>
        </CardBody>
      </Card>
    </GridItem>
  </GridContainer>
}

SummaryFigures.propTypes = {
  noSales: PropTypes.any,
  cancelled: PropTypes.any,
  voids: PropTypes.any,
  discounts: PropTypes.any
}
